<template>
  <div
    class="flex flex-col xl:flex-row items-center justify-center bg-[#2d3546] rounded-2xl p-4 mb-8 space-y-6 lg:space-y-0 lg:space-x-4"
    style="background: linear-gradient(90.59deg, #1d1d1d 0%, #313b44 100%)"
  >
    <!-- Avatar + Info -->
    <div
      class="flex flex-col sm:flex-row items-center w-full max-w-[320px] justify-center text-center sm:text-left sm:justify-start space-y-3 sm:space-y-0 sm:space-x-4 rounded-xl p-4"
      style="
        background: linear-gradient(
          90deg,
          rgba(18, 148, 240, 0.25) 0%,
          rgba(18, 148, 240, 0.5) 50%,
          rgba(18, 148, 240, 0.25) 100%
        );
      "
    >
      <img :src="getUserAvatar(picUrl)" class="w-16 h-16 rounded-full" alt="Avatar" />

      <div>
        <p class="text-white font-bold text-lg leading-5 font-montserrat">
          {{ displayName }}
        </p>
        <p class="text-sm text-white font-montserrat">Metaspins Milestone Member</p>

        <div
          class="flex items-center justify-center sm:justify-start gap-1 text-sm text-white"
        >
          <span>Rewards:</span>
          <span class="font-orbitron font-bold text-[#EEAF0E]">
            $ {{ animatedPoints.toLocaleString() }}
          </span>
        </div>
      </div>
    </div>

    <!-- Wager, Milestone, Progress -->
    <div class="grid grid-cols-2 sm:grid-cols-3 gap-4 w-full justify-items-center">
      <div
        class="flex flex-col items-center sm:flex-row sm:items-start space-x-0 sm:space-x-4 text-center sm:text-left"
      >
        <img src="../assets/milestone-coin.png" class="w-16 h-16" alt="Coin" />
        <div>
          <p class="text-sm">Current Wager</p>
          <p class="font-bold text-lg font-orbitron">
            ${{ animatedCurrentWager.toLocaleString() }}
          </p>
        </div>
      </div>

      <div
        class="flex flex-col items-center sm:flex-row sm:items-start space-x-0 sm:space-x-4 text-center sm:text-left"
      >
        <img src="../assets/milestone-flag.png" class="w-16 h-16" alt="Flag" />
        <div>
          <p class="text-sm">Next milestone</p>
          <p class="font-bold text-lg font-orbitron">
            ${{
              this.userToken
                ? getNextMilestone(milestones, totalWagers?.totalWager).nextMilestone ?? 0
                : "0.00"
            }}
          </p>
        </div>
      </div>

      <div
        class="col-span-2 sm:col-span-1 flex flex-col items-center w-full sm:flex-row sm:items-start space-x-0 sm:space-x-4 text-center sm:text-left"
      >
        <img src="../assets/milestone-rocket.png" class="w-16 h-16" alt="Rocket" />
        <div class="flex flex-col space-y-2">
          <div class="flex justify-between items-center gap-4">
            <p class="text-white text-sm">Progress</p>
            <p class="text-white font-orbitron text-lg">
              {{
                this.userToken
                  ? getNextMilestone(milestones, totalWagers?.totalWager)
                      .progressPercentage
                  : "0"
              }}%
            </p>
          </div>
          <div class="w-full h-2 bg-gray-500 rounded-full">
            <div
              class="bg-yellow-400 h-full rounded-full"
              :style="{
                width:
                  (this.userToken
                    ? getNextMilestone(milestones, totalWagers?.totalWager)
                        .progressPercentage
                    : 0) + '%',
              }"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/store";
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  data() {
    return {
      userToken: null,

      displayName: null,
      picUrl: null,
      discordID: null,

      userPoints: 0,
      animatedPoints: 0,
      animatedCurrentWager: 0,

      milestones: [],
      totalWagers: 0,
      progressBarWidth: 0,
    };
  },
  methods: {
    init() {
      this.userToken =
        store.state.user?.accessToken || localStorage.getItem("ballyboy-access-token");

      if (this.userToken) {
        axios
          .get(process.env.VUE_APP_BASE_API + "/api/user", {
            headers: {
              "x-api-key": process.env.VUE_APP_X_API_KEY,
              Authorization: `Bearer ${this.userToken}`,
            },
          })
          .then((res) => {
            if (res.data) {
              this.displayName = res.data.user.username;
              this.picUrl =
                "https://cdn.discordapp.com/avatars/" +
                res.data.user.discordId +
                "/" +
                res.data.user.profileImage +
                ".png";
              this.discordID = res.data.user.discordId;
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status === 401) {
                localStorage.removeItem("vuex");
                localStorage.removeItem("ballyboy-access-token");
                window.location.reload();
              } else {
                console.log(`Error: ${error.response.status}`);
              }
            } else if (error.request) {
              console.log("No response received", error.request);
            } else {
              console.log("Error", error.message);
            }
          });
      }
    },
    getUserAvatar(picUrl) {
      if (!picUrl || picUrl.includes("null.png")) {
        return require("../assets/avatar-1.png");
      }

      return picUrl;
    },
    initUserPoints() {
      this.userToken =
        store.state.user?.accessToken || localStorage.getItem("ballyboy-access-token");
      if (this.userToken == null) {
        this.loadingMilestones = false;
        return;
      }
      axios
        .get(process.env.VUE_APP_BASE_API + "/api/user/points", {
          headers: {
            "x-api-key": process.env.VUE_APP_X_API_KEY,
            Authorization: `Bearer ${this.userToken}`,
          },
        })
        .then((res) => {
          if (res.data) {
            this.userPoints = res.data.points;
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 401) {
              localStorage.removeItem("vuex");
              localStorage.removeItem("ballyboy-access-token");
              window.location.reload();
            } else {
              console.log(`Error: ${error.response.status}`);
            }
          } else if (error.request) {
            console.log("No response received", error.request);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    initMilestone() {
      this.userToken =
        store.state.user?.accessToken || localStorage.getItem("ballyboy-access-token");
      if (this.userToken == null) {
        return;
      }
      axios
        .get(process.env.VUE_APP_BASE_API + "/api/user/milestones", {
          headers: {
            "x-api-key": process.env.VUE_APP_X_API_KEY,
            Authorization: `Bearer ${this.userToken}`,
          },
        })
        .then((res) => {
          if (res.data) {
            this.milestones = res.data.milestones[0];
            this.totalWagers = res.data.totalWagers[0] ?? 0;

            this.animateValues();
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 401) {
              localStorage.removeItem("vuex");
              localStorage.removeItem("ballyboy-access-token");
              window.location.reload();
            } else {
              console.log(`Error: ${error.response.status}`);
            }
          } else if (error.request) {
            console.log("No response received", error.request);
          } else {
            console.log("Error", error.message);
          }
        });
    },
    animateValues() {
      this.animateNumber("animatedCurrentWager", this.totalWagers?.totalWager ?? 0);
      this.animateNumber("animatedPoints", this.userPoints);
    },
    animateNumber(variable, targetValue) {
      let startValue = this[variable] || 0;
      if (typeof startValue === "string") {
        startValue = this.parseNumber(startValue);
      }

      if (startValue === targetValue) return;

      const step = Math.max(1, Math.abs(targetValue - startValue) / 20);
      const isNegative = startValue > targetValue;

      const interval = setInterval(() => {
        if (isNegative) {
          startValue -= step;
          if (startValue <= targetValue) {
            startValue = targetValue;
            clearInterval(interval);
          }
        } else {
          startValue += step;
          if (startValue >= targetValue) {
            startValue = targetValue;
            clearInterval(interval);
          }
        }
        this[variable] = this.abbreviateNumber(Math.round(startValue));
      }, 50);
    },
    abbreviateNumber(value) {
      if (value >= 1_000_000_000) return (value / 1_000_000_000).toFixed(1) + "B";
      if (value >= 100_000_000) return (value / 1_000_000).toFixed(1) + "M";
      return value.toLocaleString();
    },
    parseNumber(formatted) {
      const num = parseFloat(formatted);
      if (formatted.endsWith("k")) return num * 1_000;
      if (formatted.endsWith("M")) return num * 1_000_000;
      if (formatted.endsWith("B")) return num * 1_000_000_000;
      if (formatted.endsWith("T")) return num * 1_000_000_000_000;
      return num;
    },
    getNextMilestone(milestoneData, currentWager) {
      const milestones = milestoneData.milestones;

      if (!milestones || milestones.length === 0) {
        return { nextMilestone: null, progressPercentage: 0, progressBarWidth: "0%" };
      }

      let lastCompletedMilestone = null;
      for (let i = 0; i < milestones.length; i++) {
        if (milestones[i].userMilestone?.status === "Completed") {
          lastCompletedMilestone = milestones[i];
        }
      }

      let nextMilestone = milestones.find(
        (m) => m.userMilestone?.status === "In Progress"
      );

      if (!nextMilestone && lastCompletedMilestone) {
        nextMilestone = milestones.find(
          (m) => m.index === lastCompletedMilestone.index + 1
        );
      }

      if (!nextMilestone) {

        const hasProgress = currentWager > 0 || lastCompletedMilestone !== null;

        return {
          nextMilestone: null,
          progressPercentage: hasProgress ? 100 : 0,
          progressBarWidth: hasProgress ? "100%" : "0%",
        };
      }

      const prevWager = lastCompletedMilestone ? lastCompletedMilestone.requiredWager : 0;
      const nextWager = nextMilestone.requiredWager;

      const rawProgress = ((currentWager - prevWager) / (nextWager - prevWager)) * 100;
      const clampedProgress = Math.min(Math.max(rawProgress, 0), 100);
      const roundedProgress = clampedProgress.toFixed(0);

      return {
        nextMilestone: nextMilestone.requiredWager,
        progressPercentage: parseInt(roundedProgress),
      };
    },
  },
  mounted() {
    this.init();
    this.initUserPoints();
    this.initMilestone();
  },
});
</script>
